var noCase = require('no-case')

/**
 * Dot case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '.')
}



//////////////////
// WEBPACK FOOTER
// ./~/dot-case/dot-case.js
// module id = 892
// module chunks = 0